import { computed, inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { CurrentUserService } from '@core/account-logic';
import { GuardedFeature } from '@core/feature-guard-legacy';
import { FeatureSpecFacade } from '@core/feature-spec-logic';
import { SalutationFieldsHelperService } from '@core/salutation-fields-logic';

@Injectable({ providedIn: 'root' })
export class CandidatePersonalDetailsFormDataService {
  private readonly featureSpecDataHelpers = inject(FeatureSpecFacade);
  private readonly currentUserService = inject(CurrentUserService);

  private readonly currentUser = toSignal(this.currentUserService.currentUser$, {
    initialValue: null,
  });
  private readonly salutationFieldsConfig = this.featureSpecDataHelpers.selectConfig(
    GuardedFeature.CandidateSalutationFields,
  );

  public hasCandidateSalutationFieldsAvailable = this.featureSpecDataHelpers.selectIsEntitled(
    GuardedFeature.CandidateSalutationFields,
  );
  public professionalTitleOptions = computed(() => {
    const config = this.salutationFieldsConfig();
    const currentUserLanguage = this.currentUser()?.preferredLanguage;
    const companyLang = (
      this.currentUser()?.companies?.find(
        company => this.currentUser()?.companyId === company.id,
      ) ?? this.currentUser()?.companies[0]
    )?.language;
    const lang = currentUserLanguage === 'auto' ? companyLang : currentUserLanguage;
    if (!config || !lang) {
      return [];
    }
    return SalutationFieldsHelperService.getProfessionalTitleOptions(config, lang);
  });
  public generalTitleOptions = computed(() => {
    const config = this.salutationFieldsConfig();
    const currentUserLanguage = this.currentUser()?.preferredLanguage;
    const companyLang = (
      this.currentUser()?.companies?.find(
        company => this.currentUser()?.companyId === company.id,
      ) ?? this.currentUser()?.companies[0]
    )?.language;
    const lang = currentUserLanguage === 'auto' ? companyLang : currentUserLanguage;
    if (!config || !lang) {
      return [];
    }
    return SalutationFieldsHelperService.getGeneralTitleOptions(config, lang);
  });
  public showSalutationFieldsUsed = computed(
    () => !!this.currentUser()?.featureDiscovery.showSalutationFieldsUsed,
  );
}
